import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { get_Admin_profile, edit_profile } from "../services/web/webServices";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Store } from "react-notifications-component";
import { MyTextInput } from "../services/authentication/inputServices";
import { useNavigate } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();
  const [avatarUrl, setAvatarUrl] = useState(""); // State to store avatar URL
  const [avatarFile, setAvatarFile] = useState(null); // State to store file object
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [getButton, setButton] = useState(true);
  const [detail, setDetail] = useState({});
  const pageName = "Profile";
  let notificationDisplayed = false;
  // Function to handle file input change

  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarUrl(reader.result); // Update the image URL to show preview
      };
      reader.readAsDataURL(file);
      setAvatarFile(file); // Save the file object
    }
  };

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  useEffect(() => {
    get_Admin_profile()
      .then((res) => {
        setDetail(res.data.data[0]);
        setAvatarUrl(res.data.data[0].avatar);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
      });
  }, []);

  const handleSubmit = (values, { resetForm }) => {
    setButton(false);

    const formData = new FormData();
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("email", values.email);
    formData.append("mobileNumber", values.mobileNumber);

    if (avatarFile) {
      formData.append("avatar", avatarFile);
    }

    edit_profile(formData)
      .then((res) => {
        if (!notificationDisplayed) {
          notificationDisplayed = true;

          setButton(true);
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true,
            },
            onRemoval: () => {
              notificationDisplayed = false;
            },
          });
        }
      })
      .catch((err) => {
        setButton(true);
        Store.addNotification({
          title: "Error!",
          message: err?.response?.data?.message,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
          },
        });
      });
  };

  const css = `
    .form-container {
      width: 700px;
      margin-top: 60px;
      padding: 40px;
      border: 1px solid #ccc;
      border-radius: 8px;
      background-color: #f0f0f0;
    }
    .form-group {
      margin-bottom: 15px;
    }
    input[type='text'],
    input[type='number'],
    input[type='email'] {
      width: 100%;
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
    button:hover {
      background-color: #076A33;
    }
    .avatar-container {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
      margin-top: 10px;
      margin-left: 250px;

    }
    .avatar-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
   
        .form-label {
        margin-bottom: 5px;
        display: block;
        font-weight: bold;
        color: #555659; 
  }
       .avatar-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;  
      align-items: center;
      background-color: #ddd;
      cursor: pointer;
      position: relative;
    }
    .pencil-icon {
      position: absolute;
      bottom: 5px; /* Adjust to fit within the circle */
      right: 5px;  /* Adjust to fit within the circle */
      color: black;
      font-size: 20px;
      cursor: pointer;
      background-color: white; /* White background for the circle */
      border-radius: 50%; /* Makes the background circular */
      padding: 8px; /* Adjust the size of the circle */
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Optional shadow for better visibility */
    }
    .pencil-icon:hover {
      color: #333;
    }
  `;

  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />

        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="form-container">
            <h2>Personal Information</h2>
            <Formik
              enableReinitialize
              initialValues={{
                firstName: detail.firstName || "",
                lastName: detail.lastName || "",
                email: detail.email || "",
                mobileNumber: detail.mobileNumber || "",
              }}
              validationSchema={Yup.object({
                firstName: Yup.string().required("First Name is required"),
                lastName: Yup.string(),
                email: Yup.string()
                  .email("Invalid email address")
                  .required("Email is required"),
                mobileNumber: Yup.string()
                  .matches(/^[0-6]{6,16}$/, "Invalid mobile number")
                  .test(
                    "len",
                    "Mobile number must be at least 6 digits",
                    (val) => val && val.length >= 6
                  ),
              })}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form>
                  <div className="form-group">
                    <div className="avatar-container">
                      {avatarUrl ? (
                        <>
                          <img
                            src={avatarUrl}
                            alt="Avatar"
                            className="avatar-image"
                          />
                          <input
                            type="file"
                            id="avatar-input"
                            name="avatar-input"
                            accept="image/*"
                            onChange={handleAvatarChange}
                            hidden
                          />
                          <label htmlFor="avatar-input">
                            <i className="fas fa-pencil pencil-icon"></i>
                          </label>
                        </>
                      ) : (
                        <div className="avatar-placeholder">
                          <label htmlFor="avatar-input">
                            <i className="fas fa-pencil pencil-icon"></i>
                          </label>
                          <input
                            type="file"
                            id="avatar-input"
                            name="avatar-input"
                            accept="image/*"
                            onChange={handleAvatarChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="firstName" className="form-label">
                      First Name
                    </label>
                    <MyTextInput
                      type="text"
                      name="firstName"
                      placeholder="Enter Your First Name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName" className="form-label">
                      Last Name
                    </label>
                    <MyTextInput
                      type="text"
                      name="lastName"
                      placeholder="Enter Your Last Name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="mobileNumber" className="form-label">
                      Mobile Number
                    </label>
                    <MyTextInput
                      type="number"
                      name="mobileNumber"
                      placeholder="Enter Your Mobile Number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <MyTextInput
                      type="email"
                      name="email"
                      placeholder="Enter Your Email"
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <button
                      type="submit"
                      style={{
                        padding: "12px",
                        backgroundColor: "#076A33",
                        width: "620px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "#fff",
                      }}
                    >
                      {getButton ? "Update" : "Please Wait..."}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
